/**
 * main.js
 *
 * Bootstraps Vuetify and other plugins then mounts the App`
 */

// Composables
import { createApp } from "vue";
import { Buffer } from "buffer";
import confirm from "@/plugins/confirm";
// Components
import App from "./pages/Main.vue";
import "@/styles/overrides.scss";
import VueGravatar from "vue3-gravatar";
import * as Sentry from "@sentry/vue";
import { i18n } from "@/i18n";

window.Buffer = Buffer;

// Plugins
import { registerPlugins } from "@/plugins";

const app = createApp(App);

registerPlugins(app);

Sentry.init({
  app,
  dsn: import.meta.env.VITE_SENTRY_URL_JS,
  integrations: [],
  release: import.meta.env.VITE_GIT_COMMITHASH
    ? `celus-${import.meta.env.VITE_GIT_COMMITHASH}`
    : "",
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT
    ? import.meta.env.VITE_SENTRY_ENVIRONMENT
    : "",
  sendDefaultPii: true,
});

app.use(i18n);
app.use(confirm);
app.use(VueGravatar);
app.mount("#app");
